import { Select } from "antd";
import { useAdvancedFormContext } from "../advanced-form";
import { InputStyled } from "./form-item-string";
import { useMemo } from "react";
import { useGetUsersLightQuery } from "../../../../api/auth-api";
import styled from "styled-components";
import { useGeneralSetting } from "../../pages/settings/general-settings";

const ReadOnlySelectStyled = styled(Select)`
  .ant-select-selector {
    background: none !important;
  }

  .ant-select-selection-item {
    color: rgba(0, 0, 0, 0.88) !important;
    background: none !important;
  }

  .ant-select-arrow {
    display: none;
  }
`

function FormItemUser({ value, onChange, readOnly, disabled, typeData }: any) {
  const [setting] = useGeneralSetting();

  const advancedFormContext = useAdvancedFormContext()
  const effectiveReadOnly = readOnly || advancedFormContext?.readOnly
  const { data: values } = useGetUsersLightQuery({ st: JSON.stringify({ lastName: "asc", firstName: "asc" }) }) as any;

  const usersForTasks = setting?.usersForTasks
  const usersList = useMemo(() => values?.filter(u => typeData?.noFilter || !usersForTasks || usersForTasks.includes(u.id)).map(u => ({ value: u.id, label: u.usernameDisplay })) || [], [values, typeData?.noFilter, usersForTasks]);
  
  const readOnlyValues = useMemo(() => (!Array.isArray(value) ? [value] : value).map(singleValue => (values?.items || []).find(v => v.value === singleValue)?.label || value).join(", "), [values, value])
  const displayValue = useMemo(() => usersList.find(u => u.value === value)?.label || value, [usersList, value])

  return <>
    { !effectiveReadOnly && <Select allowClear value={value} onChange={onChange} disabled={readOnly || disabled} options={usersList} showSearch={typeData?.showSearch} mode={typeData?.multiple ? "multiple" : undefined} />}
    { effectiveReadOnly && !typeData?.multiple && <InputStyled value={displayValue} readOnly />}
    { effectiveReadOnly && typeData?.multiple && <ReadOnlySelectStyled value={readOnlyValues} options={usersList} disabled mode="multiple" />}
  </>
}

export default FormItemUser;
